import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface IIntegrationKeyDialogData {
  integrationKey: string;
}

@Component({
  selector: 'pr-integration-key-dialog',
  templateUrl: './integration-key-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MatToolbarModule, MatTooltipModule],
})
export class IntegrationKeyDialogComponent {
  private _dialogRef =
    inject<MatDialogRef<IntegrationKeyDialogComponent>>(MatDialogRef);
  private _clipboard = inject(Clipboard);
  data = inject<IIntegrationKeyDialogData>(MAT_DIALOG_DATA);

  copy(): void {
    this._clipboard.copy(this.data.integrationKey);
  }

  download(): void {
    const blob = new Blob([this.data.integrationKey], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'integration-key.txt';
    anchor.click();
    window.URL.revokeObjectURL(url);
    this._dialogRef.close();
  }
}
